
import { i18nText } from '@/locales';

import { Component, Vue } from 'vue-property-decorator';
import { Alert, Button, DatePicker, Select, Table } from 'ant-design-vue';
import moment from 'moment';
import Api from '@/repository/api';
import { SalonsStore } from '@/store/modules/Salons';
import { getStudioId } from '@/UI/lib/state';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import PageTitle from '@/UI/components/common/PageTitle.vue';

interface ServiceReportRow {
    service_id: number;
    name: string;
    quantity: number;
    price: number;
}

@Component({ components: {
    BaseDataForm, PageTitle, 'a-alert': Alert, 'a-button': Button,
    'a-date-picker': DatePicker, 'a-select': Select, 'a-select-option': Select.Option, 'a-table': Table,
} })
export default class SalesByService extends Vue {
    salonId: number | undefined = Number(getStudioId(this)) || undefined;
    dateFrom = moment().startOf('month');
    dateTo = moment();
    salons: Array<{ id: number; name: string }> = [];
    rows: ServiceReportRow[] = [];
    loading = false;
    error = '';
    columns = [
        { title: i18nText("Услуга"), dataIndex: 'name', key: 'name' },
        { title: i18nText("Оказано"), dataIndex: 'quantity', key: 'quantity', width: 110 },
        { title: i18nText("Сумма со скидками, ₽"), dataIndex: 'price', key: 'price', width: 210, scopedSlots: { customRender: 'amount' } },
    ];

    get totalQuantity(): number { return this.rows.reduce((sum, row) => sum + Number(row.quantity), 0); }
    get totalAmount(): number { return this.rows.reduce((sum, row) => sum + Number(row.price), 0); }
    money(amount: number): string { return Number(amount).toLocaleString(this.$i18n.locale === 'en' ? 'en-US' : 'ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

    async created(): Promise<void> {
        try {
            await SalonsStore.fetchAll({ limit: 1000 });
            this.salons = SalonsStore.salons?.data || [];
            if (this.salons.length === 1 && !this.salonId) this.salonId = this.salons[0].id;
            if (this.salonId) await this.loadReport();
        } catch (e) {
            this.error = i18nText("Не удалось загрузить список филиалов. Обновите страницу.");
        }
    }

    async loadReport(): Promise<void> {
        this.error = '';
        if (!this.salonId) { this.error = i18nText("Выберите филиал."); return; }
        if (!this.dateFrom || !this.dateTo || this.dateFrom.isAfter(this.dateTo, 'day')) {
            this.error = i18nText("Укажите период: начальная дата должна быть не позже конечной.");
            return;
        }
        this.loading = true;
        this.rows = [];
        try {
            const response = await Api.get('/report/service_report', { params: {
                'filter[salon_id]': this.salonId,
                'filter[period_from]': this.dateFrom.format('YYYY-MM-DD') + ' 00:00:00',
                'filter[period_to]': this.dateTo.format('YYYY-MM-DD') + ' 23:59:59',
            } });
            if (!response.data.status || !Array.isArray(response.data.response)) throw new Error('Invalid report response');
            this.rows = response.data.response;
        } catch (e) {
            this.error = i18nText("Не удалось получить отчёт. Повторите запрос.");
        } finally {
            this.loading = false;
        }
    }
}
